import { render, staticRenderFns } from "./StatisticsTable.vue?vue&type=template&id=0167ca13&scoped=true"
import script from "./StatisticsTable.vue?vue&type=script&lang=js"
export * from "./StatisticsTable.vue?vue&type=script&lang=js"
import style0 from "./StatisticsTable.vue?vue&type=style&index=0&id=0167ca13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0167ca13",
  null
  
)

export default component.exports